// BABY REGISTRY - USES WHILE REGISTRATING USERS STARTS
jQuery(document).ready(function($) {
  $('body').on('click', '#create_customer .btn-shopnow', function(e) {
    localStorage.setItem('email', $("#create_customer input[name='customer[email]']").val());
    localStorage.setItem('password', $("#create_customer input[name='customer[password]']").val());
  })
})
// BABY REGISTRY - USES WHILE REGISTRATING USERS ENDS
